import Configuration from './Configuration';
import {PROFILE_CONSTANTS} from './PROFILE_CONSTANTS';
import store from './store';
let API_ENDPOINT = PROFILE_CONSTANTS.API_ENDPOINT;
let API_HEADERS = PROFILE_CONSTANTS.API_HEADERS;
import Vue from 'vue';

let baseURL = API_ENDPOINT;

let requestConfig = {
	method: '',
	data: {},
	headers: API_HEADERS
};

const apiFetch = async (config = {}) => {
	const {
		method = 'get',
		url,
		data,
		params,
		headers = API_HEADERS
	} = config;

	let requestUrl = url;

	if (params) {
		const searchParams = new URLSearchParams();

		Object.entries(params).forEach(([key, value]) => {
			if (value !== undefined && value !== null) {
				searchParams.set(key, value);
			}
		});

		const query = searchParams.toString();

		if (query) {
			requestUrl += `${requestUrl.includes('?') ? '&' : '?'}${query}`;
		}
	}

	const fetchOptions = {
		method: method.toUpperCase(),
		headers: { ...headers },
		credentials: 'include'
	};

	if (
		data !== undefined &&
		method.toUpperCase() !== 'GET' &&
		method.toUpperCase() !== 'HEAD'
	) {
		if (data instanceof FormData) {
			delete fetchOptions.headers['Content-Type'];
			fetchOptions.body = data;
		} else {
			fetchOptions.body =
				typeof data === 'string'
					? data
					: JSON.stringify(data);
		}
	}

	const response = await fetch(requestUrl, fetchOptions);

	let responseData = null;
	const text = await response.text();

	if (text) {
		try {
			responseData = JSON.parse(text);
		} catch {
			responseData = text;
		}
	}

	const result = {
		status: response.status,
		data: responseData,
		headers: response.headers
	};

	if (!response.ok) {
		const error = new Error(
			`Request failed with status ${response.status}`
		);

		error.response = result;

		if (response.status === 401) {
			console.debug('Unauthorized');

			Vue.$cookies.remove('au_guid', '/');
			Vue.$cookies.remove('au_profile_guid', '/');
			Vue.$cookies.remove('au_name', '/');
			Vue.$cookies.remove('au_all_memberships', '/');

			LOGOUT();
			store.commit('updateLoginModalVisibility', true);
		}

		throw error;
	}

	return result;
};

/////////////////////////////////////////////////////////////////////////////
//// ENABLE PUBLIC PROFILE
/////////////////////////////////////////////////////////////////////////////
const API_ENABLE_PUBLIC_PROFILE_SELF = (contactGUID, data) => {
	requestConfig.method = 'post';
	requestConfig.data = data;
	requestConfig.url = baseURL + `/profiles/${contactGUID}/enable`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// GET ANOTHER PROFILE BY THEIR USERNAME
/////////////////////////////////////////////////////////////////////////////
const API_GET_PUBLIC_PROFILE = username => {
	requestConfig.method = 'get';
	requestConfig.data = '';

	//TBD
	requestConfig.url = baseURL + `/profiles/${username}/public`;

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response.data))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// GET THE PUBLIC PROFILE SETTINGS BASED ON PASSING IN GUID
/////////////////////////////////////////////////////////////////////////////
const API_GET_PUBLIC_PROFILE_SELF = contactGUID => {
	requestConfig.method = 'get';
	requestConfig.data = '';
	requestConfig.url = `${baseURL}/profiles/${contactGUID}/self`;

	return new Promise((resolve, reject) => {
		apiFetch(requestConfig)
			.then(response => {
				let modifiedResponse = response.data;
				modifiedResponse.profile = {...response.data.profile};
				resolve(modifiedResponse);
			})
			.catch(error =>
				// console.log(error);
				// reject(error);
				resolve());
	});
};

/////////////////////////////////////////////////////////////////////////////
//// GET CONTACT
/////////////////////////////////////////////////////////////////////////////
const API_GET_CONTACT = contactGUID => {
	requestConfig.method = 'get';
	requestConfig.data = '';
	requestConfig.url = `${baseURL}/contacts/${contactGUID}`;

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response.data))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// PATCH CONTACT
/////////////////////////////////////////////////////////////////////////////
const API_PATCH_CONTACT = (contactGUID, data) => {
	requestConfig.method = 'patch';
	requestConfig.data = data;
	requestConfig.url = `${baseURL}/contacts/secured/${contactGUID}`;
	//must be saved as form data while every other endpoint uses JSON
	// Let the browser set the multipart/form-data boundary for FormData
	delete requestConfig.headers['Content-Type'];

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response.data))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// SAVE OWN PUBLIC PROFILE SETTINGS
/////////////////////////////////////////////////////////////////////////////
const API_PATCH_PUBLIC_PROFILE_SELF = (contactGUID, profileGUID, data) => {
	requestConfig.method = 'patch';
	requestConfig.data = data;
	requestConfig.url = `${baseURL}/profiles/${contactGUID}/${profileGUID}`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return new Promise((resolve, reject) => {
		if (contactGUID && profileGUID) {
			apiFetch(requestConfig)
				.then(response => resolve(response))
				.catch(error => reject(error));
		} else {
			reject('Invalid contactGUID or profileGUID');
		}
	});
};

/////////////////////////////////////////////////////////////////////////////
//// SAVE OWN GALLERY IMAGE DETAILS
/////////////////////////////////////////////////////////////////////////////
const API_PATCH_USER_MEDIA_SELF = data => {
	requestConfig.method = 'patch';
	requestConfig.data = data;
	requestConfig.url = `${baseURL}/media/update/`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// DELETE OWN USER MEDIA
/////////////////////////////////////////////////////////////////////////////
const API_DELETE_USER_MEDIA_SELF = async (userMediaObj, userGuid) => {
	requestConfig.method = 'delete';
	requestConfig.url = `${baseURL}/media/delete/${userMediaObj.ppd_usermediaid}/927940005/${userGuid}/true`;
	requestConfig.data = {ppd_galleryispublic: userMediaObj.ppd_galleryispublic};
	requestConfig.headers['Content-Type'] = 'application/json';
	return apiFetch(requestConfig);
};

/////////////////////////////////////////////////////////////////////////////
//// UPLOAD OWN USER MEDIA (GALLERY, PROFILE PIC, BACKGROUND)
/////////////////////////////////////////////////////////////////////////////
const API_UPLOAD_MEDIA = formdata => {
	requestConfig.method = 'post';
	requestConfig.data = formdata;
	requestConfig.url = `${baseURL}/media/create/secured`;
	// Let the browser set the multipart/form-data boundary for FormData
	// Remove Content-Type header to let the browser set it
	delete requestConfig.headers['Content-Type'];

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// DIRECT-TO-S3 UPLOADS (one photo per upload) AND AI SUGGESTIONS
/////////////////////////////////////////////////////////////////////////////
// Own config per request: the shared requestConfig carries state (url, data,
// deleted Content-Type) left behind by whatever request ran before.
const mediaUploadRequest = (method, url, data, guid) => apiFetch({
	method,
	url,
	data,
	headers: {
		...API_HEADERS,
		'Content-Type': 'application/json',
		'X-AU-Guid': guid
	}
});

const API_CREATE_MEDIA_UPLOAD = (body, guid) =>
	mediaUploadRequest('post', `${baseURL}/media/uploads`, body, guid);

const API_GET_MEDIA_UPLOAD = (uploadId, guid) =>
	mediaUploadRequest('get', `${baseURL}/media/uploads/${encodeURIComponent(uploadId)}`, undefined, guid);

const API_GET_MEDIA_SUGGESTIONS = (usermediaid, guid) =>
	mediaUploadRequest('post', `${baseURL}/media/${encodeURIComponent(usermediaid)}/suggestions`, {}, guid);

/////////////////////////////////////////////////////////////////////////////
//// GET USER GEAR
/////////////////////////////////////////////////////////////////////////////
const API_GET_USER_GEAR = contactGUID => {
	requestConfig.method = 'get';
	requestConfig.data = '';
	requestConfig.url = `${baseURL}/contacts/${contactGUID}/equipment/`;

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response.data))
		.catch(error =>
			// reject(error);
			resolve()));
};

/////////////////////////////////////////////////////////////////////////////
//// UPDATE USER GEAR
/////////////////////////////////////////////////////////////////////////////
// URL must be /contacts/:contact_guid/equipment/:ppd_gear_lockerid
// (same contact-first pattern as GET/CREATE; gear-first causes 401)
const API_PATCH_USER_GEAR = async (gearLockerId, gearObject, contactGuid) => {
	requestConfig.method = 'patch';
	requestConfig.data = JSON.stringify({gear: [gearObject]});
	requestConfig.url = `${baseURL}/contacts/${contactGuid}/equipment/${gearLockerId}`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return apiFetch(requestConfig);
};

/////////////////////////////////////////////////////////////////////////////
//// CREATE USER GEAR
/////////////////////////////////////////////////////////////////////////////
const API_CREATE_USER_GEAR = async (contactGUID, gearObject) => {
	requestConfig.method = 'post';
	requestConfig.data = JSON.stringify({gear: [gearObject]});
	requestConfig.url = `${baseURL}/contacts/${contactGUID}/equipment/`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return apiFetch(requestConfig);
};

/////////////////////////////////////////////////////////////////////////////
//// DELETE USER GEAR
/////////////////////////////////////////////////////////////////////////////
// URL must be /contacts/:contact_guid/equipment/:ppd_gear_lockerid
const API_DELETE_USER_GEAR = async (gearLockerId, contactGuid) => {
	requestConfig.method = 'delete';
	requestConfig.url = `${baseURL}/contacts/${contactGuid}/equipment/${gearLockerId}`;

	return apiFetch(requestConfig);
};

/////////////////////////////////////////////////////////////////////////////
//// UPDATE BADGES
/////////////////////////////////////////////////////////////////////////////
const API_PATCH_USER_BADGES = (profileGUID, badgeObject) => {
	requestConfig.method = 'patch';
	requestConfig.data = JSON.stringify(badgeObject);
	requestConfig.url = `${baseURL}/profiles/${profileGUID}/badging/featured`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response.data))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// DISABLE PUBLIC PROFILE
/////////////////////////////////////////////////////////////////////////////
const API_DISABLE_PUBLIC_PROFILE = contactGUID => {
	requestConfig.method = 'get';
	requestConfig.data = '';
	requestConfig.url = `${baseURL}/profiles/${contactGUID}/disable/`;

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response.data))
		.catch(error => /* reject(error); */ resolve()));
};

/////////////////////////////////////////////////////////////////////////////
//// GET MORE MEMBERS
/////////////////////////////////////////////////////////////////////////////
const API_GET_MORE_MEMBERS = ({profileGUID, memberCount}) => {
	requestConfig.method = 'get';
	requestConfig.data = '';
	requestConfig.url = `${baseURL}/profiles/moreprofiles/${profileGUID}/${memberCount}`;

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response.data))
		.catch(error => /* reject(error); */ resolve()));
};

//////////////////////////////////////////////////////////////////////////////
//// GET COMMUNITY GALLERY
/////////////////////////////////////////////////////////////////////////////
const API_GET_COMMUNITY_GALLERY = (query) => {
	let params = [];
	let { page, camera, lens, genre } = query;
	page = page || 0;
	params.push(`page=${page}`);
	if (camera) {
		params.push(`camera=${camera}`);
	}
	if (lens) {
		params.push(`lens=${lens}`);
	}
	if (genre) {
		params.push(`genre=${genre}`);
	}
	params.push(`itemsperpage=100`);
	params = params.join('&');

	requestConfig.method = 'get';
	requestConfig.data = '';
	requestConfig.url = `${baseURL}/profiles/communitygallery?${params}`;

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response.data))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// SAVE PROFILE OR PHOTO LIKE
/////////////////////////////////////////////////////////////////////////////

const API_LIKE_PROFILE_OR_PHOTO = async (likeType, likerProfileGuid, likedContentGuid) => {
	requestConfig.method = 'post';

	requestConfig.url = `${baseURL}/profiles/liking/${likeType}/${likerProfileGuid}/${likedContentGuid}`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return apiFetch(requestConfig);
};

const API_LIKE_PROFILE_OR_PHOTO_2 = async (likeType, likerGuid, likedContentGuid) => {
	requestConfig.method = 'post';

	requestConfig.url = `${baseURL}/profiles/liking2/${likeType}/${likerGuid}/${likedContentGuid}`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return apiFetch(requestConfig);
};

/////////////////////////////////////////////////////////////////////////////
//// GET PROFILE OR PHOTO LIKES
/////////////////////////////////////////////////////////////////////////////

const API_GET_PROFILE_OR_PHOTO_LIKES = likerProfileGuid => {
	requestConfig.method = 'get';
	requestConfig.data = '';
	requestConfig.url = `${baseURL}/profiles/liking/${likerProfileGuid}`;

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// GET LEAN PROFILE
/////////////////////////////////////////////////////////////////////////////
const API_GET_LEAN_PROFILE = userURL => {
	requestConfig.method = 'get';
	requestConfig.data = '';
	requestConfig.url = `${baseURL}/profiles/${userURL}/lean/`;

	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// REPORT A PROFILE OR IMAGE
/////////////////////////////////////////////////////////////////////////////
const API_REPORT_PROFILE_OR_PHOTO = async (contactGUID, data) => {
	requestConfig.method = 'post';
	// BODY: BODY: JSON object containing EITHER (1) offending profile (public guid) OR offending image (usermedia id)
	// {
	//     "ppd_publicprofileid": "12345-12345-12345-12345",
	//     "ppd_usermediaid": "13245-12345-12345-12345"
	// }
	requestConfig.data = data;
	requestConfig.url = `${baseURL}/profiles/report2/${contactGUID}`;
	requestConfig.headers['Content-Type'] = 'application/json';

	// return await apiFetch(requestConfig);
	return new Promise((resolve, reject) => apiFetch(requestConfig)
		.then(response => resolve(response))
		.catch(error => reject(error)));
};

/////////////////////////////////////////////////////////////////////////////
//// GET A SINGLE MEDIA ITEM
/////////////////////////////////////////////////////////////////////////////

const API_GET_MEDIA_ITEM = async (mediaProps) => {
	requestConfig.method = 'post';
	requestConfig.data = JSON.stringify(mediaProps);
	requestConfig.url = `${baseURL}/media/get/`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return apiFetch(requestConfig);
};

/////////////////////////////////////////////////////////////////////////////
//// GET A LIMITED DOWNLOAD TOKEN
/////////////////////////////////////////////////////////////////////////////
async function API_GET_LIMITED_DOWNLOAD_TOKEN(profileGUID) {
	requestConfig.method = 'get';
	requestConfig.url = `${baseURL}/download/limited/link/${profileGUID}`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return apiFetch(requestConfig).then(response => response).catch(error => {
		// Network errors do not have error.response
		return error.response || { status: 0, data: { message: error.message || 'Network error' } };
	});
}

/////////////////////////////////////////////////////////////////////////////
//// CHECK THE LIMITED DOWNLOAD TOKEN
/////////////////////////////////////////////////////////////////////////////
async function API_CHECK_LIMITED_DOWNLOAD_TOKEN(profileGUID, token) {
	requestConfig.method = 'get';
	requestConfig.url = `${baseURL}/download/limited/token/${profileGUID}`;
	requestConfig.params = {token};
	requestConfig.headers['Content-Type'] = 'application/json';

	return apiFetch(requestConfig).then(response => response).catch(error => {
		// Network errors do not have error.response
		return error.response || { status: 0, data: { message: error.message || 'Network error' } };
	});
}

/////////////////////////////////////////////////////////////////////////////
//// GET A LIMITED DOWNLOAD FILE
/////////////////////////////////////////////////////////////////////////////
async function API_GET_LIMITED_DOWNLOAD_FILE(profileGUID, token) {
	requestConfig.method = 'get';
	requestConfig.url = `${baseURL}/download/limited/file/${profileGUID}`;
	requestConfig.params = {token};
	requestConfig.headers['Content-Type'] = 'application/json';

	return apiFetch(requestConfig).then(response => response).catch(error => {
		// Network errors do not have error.response
		return error.response || { status: 0, data: { message: error.message || 'Network error' } };
	});
}

async function API_GET_EQUIPMENT() {
	// Create a new config object to avoid mutating shared requestConfig
	// Override baseURL to use proxy (vue.config.js) instead of API endpoint
	// Relative URLs starting with / should use current origin for proxy routing
	const config = {
		...requestConfig,
		method: 'get',
		url: `/tools/gear-list-test.json`,
		baseURL: '' // Override to use proxy instead of API endpoint
	};

	return apiFetch(config).then(response => response).catch(error => {
		// Network errors do not have error.response
		return error.response || { status: 0, data: { message: error.message || 'Network error' } };
	});
}

const API_GET_COMMUNITY_GALLERY_FILTER = async (mediaProps) => {
	// Create a new config object to avoid mutating shared requestConfig
	// Override baseURL to use proxy (vue.config.js) instead of API endpoint
	// Relative URLs starting with / should use current origin for proxy routing
	const config = {
		...requestConfig,
		method: 'get',
		url: `/tools/galleryFilterList.json`,
		baseURL: '' // Override to use proxy instead of API endpoint
	};

	return apiFetch(config).then(response => response).catch(error => {
		// Network errors do not have error.response
		return error.response || { status: 0, data: { message: error.message || 'Network error' } };
	});
};

const API_GET_OEMBED_YOUTUBE_VIDEO = async (videoUrl) => {
	requestConfig.method = 'get';
	requestConfig.url = `https://www.youtube.com/oembed`;
	requestConfig.params = {url:videoUrl, format:'json'};

	return apiFetch(requestConfig);
};

const API_GET_OEMBED_VIMEO_VIDEO = async ( videoUrl ) => {
	requestConfig.method = 'get';
	requestConfig.url = `https://vimeo.com/api/oembed.json`;
	requestConfig.params = {url:videoUrl};

	return apiFetch(requestConfig);
};

const API_GET_OEMBED_TIKTOK_VIDEO = async ( videoUrl ) => {
	requestConfig.method = 'get';
	requestConfig.url = `https://www.tiktok.com/oembed`;
	requestConfig.params = {url:videoUrl};

	return apiFetch(requestConfig);
};

const  API_UPLOAD_VIDEO = async ( data ) => {
	requestConfig.method = 'post';
	requestConfig.data = data;
	requestConfig.url = `${baseURL}/media/create/video/embedded`;
	requestConfig.headers['Content-Type'] = 'application/json';

	return apiFetch(requestConfig);
};

const API_GET_EDUCATION_INFO = async ( guid ) => {
	requestConfig.method = 'get';
	requestConfig.url = `${baseURL}/education/${guid}`;

	return apiFetch(requestConfig);
};

const GET_SERVER_DATE = async ( guid ) => {
	requestConfig.method = 'get';
	requestConfig.url = `${baseURL}/feeds/date`;

	return apiFetch(requestConfig);
};

const API_TRIGGER_CONTACT_UPDATE = async () => {
	requestConfig.method = 'get';
	requestConfig.url = `${baseURL}/auth3/updateContact`;

	return apiFetch(requestConfig);
};
const API_NEED_TO_UPDATE = async () => {
	requestConfig.method = 'get';
	requestConfig.url = `${baseURL}/auth3/needToUpdate`;

	return apiFetch(requestConfig);
};
const LOGOUT = async () => {
	requestConfig.method = 'get';
	requestConfig.url = `${baseURL}/auth3/logout`;

	return apiFetch(requestConfig);
};
export {
	API_ENABLE_PUBLIC_PROFILE_SELF,
	API_GET_CONTACT,
	API_GET_PUBLIC_PROFILE,
	API_GET_PUBLIC_PROFILE_SELF,
	API_UPLOAD_MEDIA,
	API_CREATE_MEDIA_UPLOAD,
	API_GET_MEDIA_UPLOAD,
	API_GET_MEDIA_SUGGESTIONS,
	API_DELETE_USER_MEDIA_SELF,
	API_PATCH_CONTACT,
	API_PATCH_PUBLIC_PROFILE_SELF,
	API_PATCH_USER_MEDIA_SELF,
	API_GET_USER_GEAR,
	API_PATCH_USER_GEAR,
	API_CREATE_USER_GEAR,
	API_DELETE_USER_GEAR,
	API_DISABLE_PUBLIC_PROFILE,
	API_PATCH_USER_BADGES,
	API_GET_MORE_MEMBERS,
	API_GET_COMMUNITY_GALLERY,
	API_GET_LEAN_PROFILE,
	API_REPORT_PROFILE_OR_PHOTO,
	API_LIKE_PROFILE_OR_PHOTO,
	API_LIKE_PROFILE_OR_PHOTO_2,
	API_GET_PROFILE_OR_PHOTO_LIKES,
	API_GET_MEDIA_ITEM,
	API_GET_LIMITED_DOWNLOAD_TOKEN,
	API_CHECK_LIMITED_DOWNLOAD_TOKEN,
	API_GET_LIMITED_DOWNLOAD_FILE,
	API_GET_EQUIPMENT,
	API_GET_COMMUNITY_GALLERY_FILTER,
	API_GET_OEMBED_VIMEO_VIDEO,
	API_GET_OEMBED_TIKTOK_VIDEO,
	API_GET_OEMBED_YOUTUBE_VIDEO,
	API_UPLOAD_VIDEO,
	API_GET_EDUCATION_INFO,
	GET_SERVER_DATE,
	API_TRIGGER_CONTACT_UPDATE,
	API_NEED_TO_UPDATE,
	LOGOUT,
};
